import React, { useState } from "react";
import { toast } from "react-toastify";
import { Button, Modal } from "react-bootstrap";
import { API, deleteCall } from "../../../../../config";
import Spin from "../../../../common/Spin";

const CashPaymentDelete = ({ cash_paymentId, toggleDeleteModal, handleDelete, showDelete }) => {
  const [loading, setLoading] = useState(false);

  const handlePaymentDelete = async () => {
    try {
      setLoading(true);
      const { data } = await deleteCall(`${API.CASH_PAYMENT_DELETE}/${cash_paymentId}`);
      setLoading(false);
      toast.success(data?.message);
      handleDelete();
      toggleDeleteModal();
    } catch (e) {
      setLoading(false);
      return null;
    }
  };
  return (
    <Modal
      size="lg"
      show={showDelete}
      onHide={toggleDeleteModal}
      dialogClassName="modal-50w small-popup review-popup small-review"
      aria-labelledby="contained-modal-title-vcenter"
      className="business-section"
      centered
    >
      <Modal.Header className="mb-0" closeButton>
        Delete Cash Payment
      </Modal.Header>
      <Modal.Body>
        {loading && <Spin />}
        <div className="modal-body">
          Are you sure you want to delete this cash payment?
        </div>
        <div className="modal-footer">
          <Button
            type="Button"
            className="btn btn-secondary"
            onClick={() => {
              toggleDeleteModal();
            }}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            className="btn btn-primary"
            data-dismiss="modal"
            onClick={() => {
              handlePaymentDelete();
            }}
          >
            OK
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CashPaymentDelete;
